/** Öffentliche Website-Copy — RECHTSTEXTE Abschnitt E, 16.09.2026. Keine Listenpreise. */

export const ORBIS_ALL_IN_ONE = 'All-in-One';
export const ORBIS_ALL_IN_ONE_PLATFORM = 'All-in-One-Plattform';

/** Historisch Hero-Eyebrow; auf der Startseite ausgeblendet (Andreas-Copy 17.09.2026). */
export const ORBIS_HERO_EYEBROW = 'Legal-Tech · All-in-One · EU';

/** Produktseite Orbis — unverändert, weil PRODUCT_ORBIS_HERO ohne SOLL. */
export const ORBIS_HERO_LEAD =
  'Ein Stack für Diktat, Akte und ARKO — individuell nach Kanzleigröße.';

/** Startseite Hero-Lead (ohne Marketing-Vorspann „Orbis OS —“, den die Seite davor setzt).
 *  Mix 24.09.2026: All-in-One bleibt Markenkern (Headline); Lead klingt moderner, ohne Phillips Hero A/B. */
export const ORBIS_HERO_LEAD_HOME =
  'Das moderne Arbeitsportal, das Ihre Kanzlei wirklich braucht. All-in-One statt fünf Einzeltools.';

/** Hero-E-Mail-Feld — Phillip-Übernahme (Placeholder + aria-label, nicht Live-Jargon `ihre@kanzlei.at`). */
export const HERO_EMAIL_PLACEHOLDER = 'Ihre E-Mail-Adresse';
export const HERO_EMAIL_ARIA_LABEL = 'Ihre E-Mail-Adresse';

export const BETRIEBSARTEN_KICKER = 'Betrieb';
export const BETRIEBSARTEN_TITLE = 'Zwei Betriebsarten — immer Ihr Server';
export const BETRIEBSARTEN_SUB =
  'Ob ARKORBIT den Server stellt oder Sie ihn selbst betreiben: Die Umgebung bleibt Ihrer Kanzlei zugeordnet. Demo und Kontakt klären den Umfang.';

export const BETRIEBSART_ARKORBIT_TITLE = 'Betrieb bei ARKORBIT';
export const BETRIEBSART_ARKORBIT_DESC =
  'Orbis läuft auf einem dedizierten Server, den ARKORBIT stellt (EU).';

export const BETRIEBSART_KANZLEI_TITLE = 'Betrieb auf dem Server der Kanzlei';
export const BETRIEBSART_KANZLEI_DESC =
  'Möglich — Details werden später im Gespräch geklärt. Kein Standardverkauf.';

export const WARUM_ORBIS_TITLE = 'Warum Orbis — und nicht noch ein Tool?';
export const WARUM_ORBIS_SUB =
  'Einzelne Lösungen decken Teilaufgaben ab. Orbis löst das in einer modernen All-in-One-Plattform, die Sie nicht verlassen müssen.';

export const WARUM_ORBIS_DEFICIT_TOOLCHAOS_TITLE = 'Tool-Chaos';
export const WARUM_ORBIS_DEFICIT_TOOLCHAOS_DESC =
  'Viele offene Fenster, kein klarer Durchblick, was welches Tool kann — die Hälfte bleibt ungenutzt. Nie das im Vordergrund, was Sie gerade brauchen.';

export const WARUM_ORBIS_DEFICIT_DATENSCHUTZ_TITLE = 'Datenschutz';
export const WARUM_ORBIS_DEFICIT_DATENSCHUTZ_DESC =
  'In jedes weitere geöffnete Tool gehen Ihre Daten an verschiedene Anbieter — meist in die US-Cloud. Niemand weiß danach, was damit passiert. Es fehlt eine nachweisliche Dokumentation.';

export const WARUM_ORBIS_SOLUTION_TITLE = 'Orbis-Lösung';
export const WARUM_ORBIS_SOLUTION_DESC =
  'Weniger manuelle Zwischenschritte, nachvollziehbare Dokumentation, Compliance durch Architektur statt Einzellösungen. Der Wechsel ist kein Patch — sondern ein Upgrade auf Ihre persönliche, moderne Kanzlei-Infrastruktur.';

/** Startseite #vergleich — US-Cloud vs. Edge. Shadow-AI übernommen; nie „ohne Haftungsrisiko“. */
export const VERGLEICH_US_CLOUD_ITEMS = [
  'Mandantendaten auf US-Servern',
  'CLOUD Act — Zugriff durch Dritte',
  'Kein § 9 RAO-konformes Hosting',
  'Vendor-Lock-in, Blackbox-KI',
  'Shadow-AI — Mitarbeiter nutzen KI zu Mandantenfällen',
] as const;

export const VERGLEICH_EDGE_ITEMS = [
  'Dedizierter EU-Server (Hetzner FFM)',
  'Mandantendaten bleiben bei Ihnen',
  'Ollama & Whisper lokal — kein OpenAI',
  'Ein Login, volle Kontrolle',
  'KI in der Kanzlei-Umgebung — keine Weitergabe in US-Tools',
] as const;

export const START_STEP_DEMO_DESC =
  'Kurzes Gespräch zu Infrastruktur, Datenschutz und Ihrem bestehenden Kanzlei-Setup.';
export const START_STEP_LIVE_TITLE = 'Ihr Orbis-Portal';
export const START_STEP_LIVE_DESC =
  'Ihr gewünschter Stack auf Ihrem dedizierten Server — mit den vereinbarten Bausteinen, die Sie brauchen und die nicht ungenutzt bleiben.';

/** Orbis #bausteine — Lauf A (20.09.2026): Struktur aus RECHTSTEXTE Abschnitt E, ohne Euro. */
export const BAUSTEINE_KICKER = 'Bausteine';
export const BAUSTEINE_TITLE = 'So setzt sich Orbis zusammen';
export const BAUSTEINE_SUB =
  'Basis, Sitze und Module — nach Bedarf. Kein öffentlicher Listenpreis; verbindlich wird das Angebot nach Gespräch.';

export const BAUSTEINE_BASIS_TITLE = 'Basis';
export const BAUSTEINE_BASIS_LEAD = 'Das Minimum, damit Orbis betrieben werden kann.';
export const BAUSTEINE_BASIS_ITEMS: { name: string; desc: string }[] = [
  { name: 'Orbis-Plattform', desc: 'Die Arbeitsumgebung der Kanzlei.' },
  {
    name: 'Edge-Betrieb / Hosting',
    desc: 'Nur bei Betrieb ARKORBIT — nicht bei Betrieb auf dem Server der Kanzlei.',
  },
  { name: 'Backup und Updates', desc: 'Betriebliche Mindestpflege der Instanz.' },
  { name: 'Basis-Support', desc: 'E-Mail, Werktag.' },
  { name: '1 Admin-Zugang', desc: 'Ein administrativer Zugang; weitere Personen als Sitze.' },
];

export const BAUSTEINE_SITZE_TITLE = 'Sitze';
export const BAUSTEINE_SITZE_LEAD =
  'Weitere Personen kommen als Sitze dazu. Ein Admin-Zugang ist in der Basis enthalten.';

export const BAUSTEINE_MODULE_TITLE = 'Module nach Bedarf';
export const BAUSTEINE_MODULE_LEAD = 'Zeile je Modul — Umfang im Gespräch, ohne öffentlichen Preis.';
export const BAUSTEINE_MODULE_ITEMS: { name: string; desc: string }[] = [
  { name: 'Diktat', desc: 'Aufnahme und Transkription im Kanzlei-Alltag.' },
  { name: 'ARKO', desc: 'KI-Rechtsassistent mit Mandatskontext.' },
  { name: 'LEXCORE', desc: 'Kuratierte Normen nach Fachgebiet.' },
  { name: 'JUD', desc: 'OGH-Judikatur nach Bedarf.' },
  { name: 'Litigation', desc: 'Schriftsatz-Analyse; Umfang im Angebot.' },
];

export const HOME_BAUSTEINE_TEASER_TITLE = 'So setzt sich Orbis zusammen';
export const HOME_BAUSTEINE_TEASER_SUB =
  'Basis, Sitze und Module — nach Bedarf, ohne öffentlichen Listenpreis.';
export const HOME_BAUSTEINE_TEASER_CTA = 'Zur Übersicht';
